import cn from "classnames";
import type {AppContentProps} from "./Content.types";
import styles from "./Content.module.scss";

export const AppContent = (props: AppContentProps) => {
  return (
    <main className={cn(styles.main, props.className)}>
      <div className={cn(styles.content, props.contentClassName)}
           style={props.style}>
        {props.children}
      </div>
    </main>
  );
};
